<template>
  <div class="c-alert c-alert--success">
    <div v-html="successConfirmationMessage"></div>
  </div>
  <!-- <div v-if="!emailConfirmationSuccess" class="c-alert c-alert--danger">
    Het versturen van de e-mail is helaas niet gelukt.
  </div> -->
  <div class="o-form">
    <Contact />
    <div class="o-input">
      <label class="o-input__label">Betaald</label>
      <div class="o-input__controls">
        <p>{{ formatCurrency(totalCost) }} euro</p>
      </div>
    </div>
  </div>
  <footer class="c-container__footer">
    <div class="o-toolbar">
      <div class="o-toolbar__left"><button type="button" class="c-button c-button--default" @click="restart">Nieuwe bestelling</button></div>
      <div class="o-toolbar__right"><button type="button" class="c-button c-button--default" @click="print">Bevestiging afdrukken</button></div>
    </div>
  </footer>
</template>

<script>
import { useConfig } from "@/app-config";
import { formatCurrency } from "@/infrastructure/utilities";

import Contact from "@/components/order/Contact";

import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { computed } from "vue";

export default {
  components: { Contact },
  setup() {
    const store = useStore();
    const router = useRouter();
    const appConfig = useConfig();

    const successConfirmationMessage = computed(() => store.state.webshop.successConfirmation);
    const totalCost = computed(() => store.getters["orders/totalCostWithDiscount"]);
    const emailConfirmationSuccess = computed(() => store.getters["orders/emailConfirmationSuccess"]);

    return {
      successConfirmationMessage,
      totalCost,
      emailConfirmationSuccess,
      formatCurrency,
      async restart() {
        // reload to homepage so state is also reset
        location = appConfig.baseUrl + "/?appId=" + store.state.appId;
      },
      print() {
        router.push({ name: "print" });
      },
    };
  },
};
</script>
